import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Drawer,
  FormControl,
  FormControlLabel,
  InputAdornment,
  Radio,
  RadioGroup,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Autocomplete } from "@material-ui/lab";
import SearchIcon from "@material-ui/icons/Search";
// import CdmoWarning from "./CdmoWarning";
import axios from "axios";
import { appUrl } from "../../../../../../utils/config";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    minHeight: "90%",
  },
  textFieldWrapper: {
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: "flex",
    alignItems: "flex-end",
    justifyContent: "space-between",
    marginTop: "auto",
    marginBottom: theme.spacing(2),
    textTransform: "none",
  },
  content: {
    flexGrow: 1,
  },

  heading: {
    fontWeight: 600,
    marginBottom: "1em",
  },
  drawerPaper: {
    width: "30vw",
  },
  saveBtn: {
    backgroundColor: "#286acf",
    textTransform: "none",
    color: "#fff",
    "&:hover": {
      backgroundColor: "#286acf",
    },
  },
}));
// const dummyAPI = [
//   { cdmo_name: "Oxford Biomedica", cdmo_id: "1" },
//   { cdmo_name: "Recipharm", cdmo_id: "2" },
//   { cdmo_name: "Catalent", cdmo_id: "3" },
//   { cdmo_name: "AGC Life Sciences", cdmo_id: "4" },
//   { cdmo_name: "Lonza", cdmo_id: "5" },
//   { cdmo_name: "Thermo Fisher", cdmo_id: "6" },
//   { cdmo_name: "WuXi Biologics", cdmo_id: "7" },
//   { cdmo_name: "Samsung Biologics", cdmo_id: "8" },
//   { cdmo_name: "Piramal Pharma", cdmo_id: "9" },
//   { cdmo_name: "Almac", cdmo_id: "10" },
//   { cdmo_name: "Patheon", cdmo_id: "11" },
//   { cdmo_name: "AMRI", cdmo_id: "12" },
//   { cdmo_name: "Baxter BioPharma", cdmo_id: "13" },
//   { cdmo_name: "Cambrex", cdmo_id: "14" },
//   { cdmo_name: "Vetter Pharma", cdmo_id: "15" },
//   { cdmo_name: "Ajinomoto Bio-Pharma", cdmo_id: "16" },
//   { cdmo_name: "Fujifilm Diosynth", cdmo_id: "17" },
//   { cdmo_name: "CordenPharma", cdmo_id: "18" },
//   { cdmo_name: "Evonik", cdmo_id: "19" },
//   { cdmo_name: "Hovione", cdmo_id: "20" },
//   { cdmo_name: "Biocon", cdmo_id: "21" },
//   { cdmo_name: "Strides Pharma", cdmo_id: "22" },
//   { cdmo_name: "Dishman Carbogen Amcis", cdmo_id: "23" },
//   { cdmo_name: "Siegfried", cdmo_id: "24" },
//   { cdmo_name: "Lupin", cdmo_id: "25" },
//   { cdmo_name: "Dr. Reddy's", cdmo_id: "26" },
//   { cdmo_name: "Mylan", cdmo_id: "27" },
//   { cdmo_name: "Aurobindo Pharma", cdmo_id: "28" },
//   { cdmo_name: "Sanofi", cdmo_id: "29" },
//   { cdmo_name: "GSK", cdmo_id: "30" },
//   { cdmo_name: "Pfizer", cdmo_id: "31" },
//   { cdmo_name: "Roche", cdmo_id: "32" },
//   { cdmo_name: "Bayer", cdmo_id: "33" },
//   { cdmo_name: "Novartis", cdmo_id: "34" },
//   { cdmo_name: "Merck", cdmo_id: "35" },
//   { cdmo_name: "Teva", cdmo_id: "36" },
//   { cdmo_name: "Celgene", cdmo_id: "37" },
//   { cdmo_name: "Shire", cdmo_id: "38" },
//   { cdmo_name: "Boehringer Ingelheim", cdmo_id: "39" },
//   { cdmo_name: "AstraZeneca", cdmo_id: "40" },
//   { cdmo_name: "Sponsor", cdmo_id: "41" },
//   { cdmo_name: "Vertex Pharmaceuticals", cdmo_id: "42" },
//   { cdmo_name: "Biogen", cdmo_id: "43" },
//   { cdmo_name: "Regeneron", cdmo_id: "44" },
//   { cdmo_name: "AbbVie", cdmo_id: "45" },
//   { cdmo_name: "Eli Lilly", cdmo_id: "46" },
//   { cdmo_name: "Novo Nordisk", cdmo_id: "47" },
//   { cdmo_name: "Ipsen", cdmo_id: "48" },
//   { cdmo_name: "Takeda", cdmo_id: "49" },
//   { cdmo_name: "UCB", cdmo_id: "50" },
//   { cdmo_name: "Endo International", cdmo_id: "51" },
//   { cdmo_name: "Sun Pharma", cdmo_id: "52" },
//   { cdmo_name: "Zydus Cadila", cdmo_id: "53" },
//   { cdmo_name: "Torrent Pharma", cdmo_id: "54" },
//   { cdmo_name: "Alembic", cdmo_id: "55" },
// ];

export default function AssociateCDMOs({
  user,
  setViewDetailsDrawer,
  handleRefresh,
}) {
  const classes = useStyles();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [cdmoAPI, setCdmoAPI] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [discard, setDiscard] = useState(false); //toggle
  const [accessOption, setAccessOption] = useState(""); // Default to 'all' radio button
  const [associatedIds, setAssociatedIds] = useState(
    user?.associatedCDMOOrgIDs
  );
  const [cdmoDrawer, setCdmoDrawer] = useState(false);
  // Handle radio button change
  const handleAccessChange = (event) => {
    const value = event.target.value;
    setAccessOption(value);
    if (value === "all") {
      setSelectedOptions([]);
      setAssociatedIds("all");
    } else setAssociatedIds("");
  };
  //fetch all cdmos
  useEffect(() => {
    setLoading(true);
    setAccessOption(user?.associatedCDMOOrgIDs === "all" ? "all" : "select");

    // const url =
    //   "https://api.mockfly.dev/mocks/6068d47d-50f1-44a0-bc11-f2a155dab121/fetchCdmoDetails";
    const url = `${appUrl}/user/fetchCdmoDetails`;

    axios
      .get(url)
      .then((res) => {
        if (res.data.status) {
          const options = user.associated_cdmo_list
            .map((selected) =>
              res.data.data.find((item) => item.cdmo_id === selected.cdmo_id)
            )
            .filter(Boolean);
          if (user.associatedCDMOOrgIDs === "all") {
            setSelectedOptions([]);
            setAssociatedIds("all");
          } else {
            setSelectedOptions(options);
          }
          setCdmoAPI(res.data.data);
        } else setCdmoAPI([]);
      })
      .catch((err) => {
        setError(true);
        console.error(err.message);
      })
      .finally(() => setLoading(false));
  }, [discard]);

  const handleSave = () => {
    setCdmoDrawer(true);
  };
  const displayLoading = (
    <div style={{ textAlign: "center", marginTop: "1.5em" }}>
      <CircularProgress color="primary" thickness={7} />
    </div>
  );
  const displayError = (
    <Box
      style={{
        border: "2px solid rgb(255,0,0)",
        backgroundColor: "rgb(255,240,240)",

        textAlign: "center",
        padding: "0.8rem",
        fontSize: "0.875rem",
        marginTop: "1.5em",
      }}
    >
      {" "}
      <Typography variant="body2">
        Something went wrong. Please try again later.
      </Typography>
    </Box>
  );

  const displayNoRecordsFound = (
    <Box
      style={{
        display: "flex",
        justifyContent: "center", // Horizontally center the CircularProgress
        alignItems: "center", // Vertically center the CircularProgress
        height: "50px", // Optional: Set a height to vertically center the loader
        border: "2px solid #000",
        // backgroundColor: "#FFF0F0",
        width: "100%",
        marginTop: "1.5em",
      }}
    >
      <Typography style={{ textAlign: "center" }}>No records found</Typography>
    </Box>
  );
  if (loading) return displayLoading;
  if (error) return displayError;
  if (cdmoAPI?.length === 0) return displayNoRecordsFound;
  return (
    <Box
      style={{ minHeight: "100%", display: "flex", flexDirection: "column" }}
    >
      <Typography className={classes.heading}>Associate CMOs</Typography>
      <FormControl style={{ width: "100%" }}>
        <RadioGroup style={{ display: "flex", flexDirection: "column" }} value={accessOption} onChange={handleAccessChange}>
          <FormControlLabel
            value="all"
            control={<Radio color="primary" disabled />}
            label={
              <span style={{ fontSize: "14px" }}>
                {`Access all CMOs (${cdmoAPI.length} CMOs)`}
              </span>
            }
          />
          <FormControlLabel
            value="select"
            control={<Radio color="primary" disabled />}
            label={
              <span style={{ fontSize: "14px" }}>Access select CMOs</span>
            }
          />
        </RadioGroup>
      </FormControl>
      <FormControl style={{ width: "100%", height: "100%" }}>
        <Autocomplete
          multiple
          size="small"
          value={selectedOptions}
          options={cdmoAPI}
          getOptionLabel={(option) => option.cdmo_name}
          onChange={(event, value) => {
            setSelectedOptions(value);
            setAssociatedIds(value.map((option) => option.cdmo_id).join(","));
          }}
          disabled={accessOption === "all"}
          disableCloseOnSelect
          renderInput={(params) => (
            <TextField
              size="small"
              {...params}
              variant="outlined"
              placeholder="Start typing to search"
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon fontSize="small" />
                  </InputAdornment>
                ),
              }}
            />
          )}
          renderOption={(option, { selected }) => (
            <React.Fragment>
              <Checkbox
                checked={selected}
                style={{ marginRight: 8 }}
                color="primary"
              />
              {option.cdmo_name}
            </React.Fragment>
          )}
        />
      </FormControl>
      <FormControl
        style={{ marginTop: "1em", marginBottom: "1em", width: "100%" }}
      >
        <Typography variant="body1">Your selections</Typography>
        <TextField
          disabled
          size="small"
          minRows={4}
          fullWidth
          value={
            selectedOptions.map((option) => option.cdmo_name).join(", ") || ""
          } // Display selected names
          variant="outlined"
          InputProps={{
            readOnly: true,
          }}
          multiline
          style={{ width: "100%" }}
        />
      </FormControl>

      {/* <Box className={classes.buttonContainer}>
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            setDiscard((prev) => !prev);
          }}
          style={{ textTransform: "none" }}
        >
          Discard changes
        </Button>
        <Button
          size="small"
          variant="contained"
          className={classes.saveBtn}
          disabled={associatedIds === ""}
          onClick={handleSave}
        >
          Save changes
        </Button>
      </Box> */}
      {/* <Drawer
        anchor="right"
        open={cdmoDrawer}
        onClose={() => setCdmoDrawer(false)}
        classes={{ paper: classes.drawerPaper }}
        BackdropProps={{ style: { backgroundColor: "transparent" } }}
      >
        <CdmoWarning
          setCdmoDrawer={setCdmoDrawer}
          associatedIds={associatedIds}
          user={user}
          setViewDetailsDrawer={setViewDetailsDrawer}
          handleRefresh={handleRefresh}
        />
      </Drawer> */}
    </Box>
  );
}
